/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/react-in-jsx-scope */
import ContainerWithSidebar from "@/components/Sidebar";
import { profileSidebarMenuList } from "@/config";
import Store from "@/store";
import CommonStore from "@/store/common";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import MarketContractStore, { IAssetPrice } from "@/store/contract";
import MyWalletStore, { IMyAsset } from "@/store/my-wallet";
import numeral from "numeral";
import {
  Button,
  Card,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  OutlinedInput,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import { BigNumber, ethers } from "ethers";
import { inject, observer } from "mobx-react";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { enqueueSnackbar } from "notistack";
import { useAccount, useWalletClient } from "wagmi";
import { MonetizationOnOutlined } from "@mui/icons-material";
import DialogInprogress from "@/components/DialogInprogress/DialogInprogress";
import { copyToClipboard, truncateAddress } from "@/utility";
const MyWallet = inject(
  Store.type.myWalletStore,
  Store.type.contractStore,
  Store.type.commonStore,
)(
  observer((props: any) => {
    const contractStore = props[
      Store.type.contractStore
    ] as MarketContractStore;
    const theme = useTheme();

    const myWalletStore = props[Store.type.myWalletStore] as MyWalletStore;
    const commonStore = props[Store.type.commonStore] as CommonStore;
    const assetPrices = contractStore.assetPrices;
    const assets = commonStore.assets;
    const assetBalances = myWalletStore.myAssets;
    const [openInprogress, setOpenInprogress] = useState(false);
    const { address } = useAccount();
    const signer = useWalletClient();
    const [handleWatchBalace, setHandleWatchBalace] = useState<any>(undefined);
    const {
      register,
      control,
      reset,
      formState: { errors },
      handleSubmit,
    } = useForm<{ amount: "" }>();
    const [open, setOpen] = useState(false);
    const [action, setAction] = useState({
      type: "",
      title: "",
      assetAddress: "",
      assetSymbol: "",
      label: "",
    });
    const handleClose = () => {
      setOpen(false);
    };
    const handleOpen = (
      type: string,
      assetAddress: string,
      assetSymbol: string,
    ) => {
      setAction({
        type,
        title: type === "deposit" ? "Deposit" : "Withdraw",
        assetAddress: assetAddress,
        label: type === "deposit" ? "Deposit" : "Withdraw",
        assetSymbol: assetSymbol,
      });
      setOpen(true);
    };
    const onSubmit = async (data: { amount: string }) => {
      setOpen(false);
      setOpenInprogress(true);
      commonStore.setTransactionProcessing(true);
      try {
        if (action.type === "deposit") {
          await myWalletStore.deposit(
            action.assetAddress,
            ethers.utils.parseEther(data.amount),
          );
        } else {
          await myWalletStore.withdraw(
            action.assetAddress,
            ethers.utils.parseEther(data.amount),
          );
        }
        enqueueSnackbar("Transaction successful", {
          variant: "success",
        });
      } catch (error: any) {
        console.log(error);
        if (
          (error.message as string).includes(
            "reverted: P2PWallet: User with this wallet address is not KYC verified",
          )
        ) {
          enqueueSnackbar(`Transaction failed. Please KYC first to continue.`, {
            variant: "error",
          });
        } else {
          enqueueSnackbar(
            "Transaction failed. Please check your wallet and try again.",
            {
              variant: "error",
            },
          );
        }
      }
      setOpenInprogress(false);
      commonStore.setTransactionProcessing(false);

      reset();
    };
    useEffect(() => {
      if (signer.isLoading == false) {
        for (let i = 0; i < assets.length; i++) {
          const asset = assets[i];
          myWalletStore.setAssets(assets);
          contractStore.fetchAssetPrice(asset.address);
          myWalletStore.fetchBalancesOfTokens(asset.address);
        }
      }
    }, [address, assets, signer.isLoading]);
    const getBalancesFiat = (
      myasset: IMyAsset[],
      assetPrices: IAssetPrice[],
    ) => {
      const balance = myasset
        .map((asset: IMyAsset) => {
          const assetPrice = assetPrices.find(
            (assetPrice) => assetPrice.address === asset.asset.address,
          );
          if (assetPrice) {
            return asset.balance
              ?.mul(assetPrice.price)
              .div(ethers.utils.parseEther("1"));
          }
          return BigNumber.from(0);
        })
        .reduce((a, b) => a?.add(b!), BigNumber.from(0));
      return ethers.utils.formatEther(balance || "0");
    };
    useEffect(() => {
      if (!handleWatchBalace) {
        setHandleWatchBalace(
          setInterval(() => {
            for (let i = 0; i < assets.length; i++) {
              const asset = assets[i];
              myWalletStore.fetchBalancesOfTokens(asset.address);
            }
          }, 10000),
        );
      }
      return () => {
        if (handleWatchBalace) {
          clearInterval(handleWatchBalace);
        }
      };
    }, []);
    return (
      <>
        <ContainerWithSidebar menu={profileSidebarMenuList}>
          <Container
            maxWidth="lg"
            sx={{
              py: "82px",
              [theme.breakpoints.up("lg")]: { maxWidth: "lg", py: "82px" },
            }}
          >
            <Card>
              <Stack
                spacing={2}
                direction="column"
                justifyContent="center"
                alignItems="center"
              >
                <Typography variant="h2" component={"h2"}>
                  My Wallet
                </Typography>
                <MonetizationOnOutlined sx={{ fontSize: 40 }} color="primary" />
                <Typography variant="h6">Balance</Typography>
                <Typography variant="h4">
                  ${" "}
                  {numeral(getBalancesFiat(assetBalances, assetPrices)).format(
                    "0.00",
                  )}
                </Typography>
                {assetBalances.length > 0 && (
                  <TableContainer>
                    <Table sx={{ minWidth: 650 }}>
                      <TableHead>
                        <TableRow>
                          <TableCell>Asset</TableCell>
                          <TableCell>Address</TableCell>
                          <TableCell>Balance</TableCell>
                          <TableCell>Market Price($)</TableCell>
                          <TableCell width={100}>Deposit/Withdraw </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {assetBalances.map((assetBalance: IMyAsset) => {
                          const assetPrice = assetPrices.find(
                            (assetPrice) =>
                              assetPrice.address === assetBalance.asset.address,
                          );
                          return (
                            <TableRow key={assetBalance.asset.address}>
                              <TableCell>{assetBalance.asset.symbol}</TableCell>
                              <TableCell>
                                {!assetBalance.asset.address.includes(
                                  "0x00000",
                                ) && (
                                  <>
                                    <Button
                                      variant={"text"}
                                      size="small"
                                      onClick={() => {
                                        copyToClipboard(
                                          assetBalance.asset.address,
                                        );
                                      }}
                                      endIcon={<FileCopyIcon />}
                                    >
                                      {truncateAddress(
                                        assetBalance.asset.address,
                                      )}
                                    </Button>
                                  </>
                                )}
                              </TableCell>
                              <TableCell>
                                {numeral(
                                  ethers.utils.formatEther(
                                    assetBalance.balance.toString() || "",
                                  ),
                                ).format("0,0.000")}
                              </TableCell>
                              <TableCell>
                                {numeral(
                                  ethers.utils.formatEther(
                                    (assetPrice &&
                                      assetPrice.price.toString()) ||
                                      "0",
                                  ),
                                ).format("0,0.00")}
                              </TableCell>
                              <TableCell
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  gap: "10px",
                                }}
                              >
                                <Button
                                  variant="outlined"
                                  size="small"
                                  onClick={() =>
                                    handleOpen(
                                      "withdraw",
                                      assetBalance.asset.address,
                                      assetBalance.asset.symbol,
                                    )
                                  }
                                >
                                  Withdraw
                                </Button>
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={() =>
                                    handleOpen(
                                      "deposit",
                                      assetBalance.asset.address,
                                      assetBalance.asset.symbol,
                                    )
                                  }
                                >
                                  Deposit
                                </Button>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Stack>
            </Card>
          </Container>
        </ContainerWithSidebar>

        <Dialog open={open} maxWidth={"md"} onClose={handleClose}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <DialogTitle>
              <Typography variant="h4">{action.title}</Typography>
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={2} sx={{ minWidth: 500 }}>
                <Grid item xs={12} md={12}>
                  <Controller
                    name="amount"
                    control={control}
                    defaultValue={""}
                    rules={{
                      required: "Amount is required",
                      validate: {
                        positive: (value) =>
                          parseFloat(value) > 0 || "Amount must be positive",
                        number: (value: string) => {
                          try {
                            ethers.utils.parseEther(value);
                            return true;
                          } catch (error) {
                            return "Invalid amount";
                          }
                        },
                      },
                    }}
                    render={({ field }) => (
                      <FormControl fullWidth variant="outlined">
                        <OutlinedInput
                          autoComplete="off"
                          inputProps={{
                            placeholder: "Enter Amount",
                            type: "number",
                          }}
                          sx={{
                            border: "1px solid #e0e0e0",
                            borderRadius: "10px",
                          }}
                          error={!!errors.amount}
                          fullWidth
                          {...field}
                          {...register("amount")}
                        />

                        <FormHelperText error={!!errors.amount}>
                          {!!errors.amount && errors.amount?.message}
                        </FormHelperText>
                      </FormControl>
                    )}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button size="large" variant="outlined" onClick={handleClose}>
                Cancel
              </Button>
              <Button size="large" variant="contained" type="submit">
                {action.label}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
        <DialogInprogress
          open={openInprogress}
          onClose={() => {
            setOpenInprogress(false);
          }}
        />
      </>
    );
  }),
);
export default MyWallet;
